import React, { Component } from 'react';
import { packBarCode, parseBarCode } from './parser';
import './ScanButton.css';

const options = {
  scanButtonKeyCode: 0,
  suffixKeyCode: 13,
};

export default class ScanButton extends Component {
  constructor(props) {
    super(props);
    this.state = { sCode: '', scanning: false };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.stopScan();
  }

  handleKeyDown = (event) => {
    const keyCode = event.which || event.keyCode;
    if (keyCode === options.scanButtonKeyCode) {
      // start scanning
      event.preventDefault();
      event.stopImmediatePropagation();
      this.startScan();
    } else if (keyCode === options.suffixKeyCode) {
      // finish scanning
      event.preventDefault();
      event.stopImmediatePropagation();
      this.decodeText(this.state.sCode);
      this.stopScan();
    }
  };

  startScan = () => {
    if (this.state.scanning) {
      return;
    }
    // Prevent the on-screen keyboard from appearing by setting it to read-only.
    this.setState({ scanning: true });
    this.inputRef.readOnly = true;
    this.inputRef.focus();
    setTimeout(() => {
      this.inputRef.readOnly = false;
    }, 0);
  };

  stopScan = () => {
    this.inputRef.readOnly = true;
    this.setState({ sCode: '', scanning: false });
  };

  decodeText = (value) => {
    if (this.props.onScan) {
      const text = value.replace(/[^0-9a-zA-Z-.]/g, '*');
      const decoded =
        this.props.type === 'direct' ? packBarCode(text) : parseBarCode(text);
      this.props.onScan(decoded);
    }
  };

  handleChange = (event) => {
    if (this.state.scanning) {
      this.setState({ sCode: event.target.value });
    }
  };

  render() {
    const className = this.props.debug
      ? 'scan-button-debug'
      : 'scan-button-wrapper';

    return (
      <div className={className}>
        <input
          key={this.inputKey}
          ref={(ref) => {
            this.inputRef = ref;
          }}
          value={this.state.sCode}
          onBlur={this.stopScan}
          onChange={this.handleChange}
          placeholder={this.state.scanning ? 'Scanning...' : 'Waiting...'}
        />
        <div className='overlay'></div>
      </div>
    );
  }
}
